<template>
  <v-container id="fileList" fluid>
    <v-row>
      <v-col>
        <v-progress-linear :active="innerLoading" color="loader" indeterminate />
      </v-col>
    </v-row>
    <v-data-iterator
        :items="documentList"
        hide-default-footer
        disable-pagination
        disable-filtering
        item-key="documentType"
        :locale="systemLocale">
      <template v-slot="props">
        <v-row justify="center">
          <v-col
              v-for="item in props.items"
              :key="item.documentType"
              cols="12"
              sm="10"
              md="5"
              xl="4"
              class="py-1">
            <v-card>
              <v-card-title>
                <v-row
                    class="v-label textcolor--text subtitle-2 font-weight-bold">
                  <v-col
                      cols="12"
                      class="py-1 ml-1 text-left">
                    <link-with-tip
                        v-if="item.templatePath"
                        :href="item.templatePath"
                        :tip="$t('Скачать шаблон документа')"
                        :text="item.documentDescription" />
                    <span v-else class="py-2">
                      {{ item.documentDescription }}
                    </span>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider />
              <v-row class="text-left px-1 py-3">
                <v-col cols="12" class="px-0 py-0">
                  <text-view
                      :display="item.fileName"
                      :no-data="$t('Не загружен')"
                      :label="$t('Файл')"
                      icon="attach_file" />
                </v-col>
              </v-row>
              <v-divider v-if="item.fileId" />
              <v-card-text>
                <v-row v-if="item.fileId">
                  <v-col cols="12" class="text-center py-1">
                    <btn-icon-tip
                        :id="`getFile-${item.fileId}`"
                        icon="get_app"
                        :tip=" $t('Скачать документ')"
                        @click="getBusinessFile(item.fileId)" />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import TextView from '@/components/reused/ui/TextView.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import LinkWithTip from '@/components/reused/ui/LinkWithTip.vue'
  import getFileMixin from '@/utils/mixins/scoped/getFileMixin.js'

  export default {
    components: {
      BtnIconTip,
      LinkWithTip,
      TextView
    },
    mixins: [
      getFileMixin('isLoading')
    ],
    props: {
      documentTypes: {
        type: Array,
        default: () => {
          return []
        }
      },
      requestFiles: {
        type: Array,
        default: () => {
          return []
        }
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
      innerLoading () {
        return this.isLoading || this.loading
      },
      documentList () {
        const requiredDocumentTypes = this.documentTypes || []
        const requestFiles = this.requestFiles || []
        const list = requiredDocumentTypes.map(item => {
          const docType = item.documentType
          const template = Vue.getDocumentTemplateInfo(docType)
          const savedFile = requestFiles.find(f => f.documentType === docType)
          let templatePath
          if (template && template.path) {
            templatePath = this.getSystemFileUrl(template.path)
          }
          if (savedFile) {
            return {
              ...item,
              ...savedFile,
              templatePath
            }
          }
          return {
            ...item,
            templatePath
          }
        })
        return list
      }
    },
    methods: {

    }
  }
</script>
